import React from "react";

export function isRightMouseClick(e: React.MouseEvent) {
  return e.button === 2;
}

export function hasSelectionModifier(e: React.MouseEvent) {
  return e.ctrlKey || e.metaKey || e.shiftKey;
}

export function isToggleSelectClick(e: React.MouseEvent) {
  return e.ctrlKey || e.metaKey;
}
